import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';

import { RadioComponent } from './radio.component';

@NgModule({
    declarations: [
        RadioComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        RadioComponent
    ]
})

/**
 * Module for Radio component
 */
export class RadioModule { }